import { getSavedLocation } from '@theme/delivery-location-service';

/**
 * Applies the "location set" visual state — green pin + corner badge, no
 * address text — to every `[data-delivery-location-trigger]` on the page
 * (header trigger, hamburger drawer item). Reads storage directly via
 * `@theme/delivery-location-service` instead of waiting on
 * `<delivery-location-modal>`'s `connectedCallback` (see
 * assets/delivery-location.js#updateHeaderLabel, which does the same thing
 * once the modal itself connects). That modal is rendered near the end of
 * `<body>` (layout/theme.liquid), after the header and hamburger drawer, so
 * relying on it alone left the triggers rendering in their default/unset
 * state first and only flipping to "set" once the modal's custom element
 * upgraded — visible as the badge "resetting" on every load for shoppers
 * who already have a saved location. Running this immediately, independent
 * of that element, removes the gap entirely.
 */
function applyTriggerState() {
  const hasSelection = Boolean(getSavedLocation()?.address);

  for (const trigger of document.querySelectorAll('[data-delivery-location-trigger]')) {
    trigger.classList.toggle('delivery-location-trigger--set', hasSelection);
  }

  // Static "Location is set" tooltip text is server-rendered directly in
  // Liquid (see snippets/header-actions.liquid) — this only ever toggles
  // its visibility, never its content, so it works the same regardless of
  // this module's other state.
  for (const tooltip of document.querySelectorAll('[data-delivery-location-header-tooltip]')) {
    if (tooltip instanceof HTMLElement) {
      tooltip.hidden = !hasSelection;
    }
  }
}

applyTriggerState();

document.addEventListener('delivery-location:change', applyTriggerState);
